import { render, staticRenderFns } from "./Alerta.vue?vue&type=template&id=b9ee7cbc&scoped=true"
import script from "./Alerta.vue?vue&type=script&lang=js"
export * from "./Alerta.vue?vue&type=script&lang=js"
import style0 from "./Alerta.vue?vue&type=style&index=0&id=b9ee7cbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ee7cbc",
  null
  
)

export default component.exports